import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Filter from './Filter';

const selectors = createStructuredSelector({});
const actions = {};

export default connect(selectors, actions)(Filter);
